// Inspired by https://github.com/payloadcms/payload/blob/main/packages/richtext-lexical/src/features/converters/lexicalToJSX/converter/converters/paragraph.tsx
import React from "react";
import { Text } from "@disco/disco_core";

const ParagraphGenerator = {
	paragraph: ({ node, nodesToJSX }) => {
		const children = nodesToJSX({
			nodes: node.children,
		});

		return <Text size="body">{children}</Text>;
	},
};

export default ParagraphGenerator;
